import { TaxRateInterface } from '@vendasta/billing';

export const isTaxRate = (tr: TaxRate | undefined): tr is TaxRate => {
  return !!tr;
};

export interface TaxRate {
  id?: string;
  merchantId?: string;
  countryCode?: string;
  stateCode?: string;
  name?: string;
  description?: string;
  percentage?: number;
  accountingSystemId?: string;
}

export function taxRateFromApi(apiTaxRate: TaxRateInterface): TaxRate {
  return {
    id: apiTaxRate.id || '',
    merchantId: apiTaxRate.merchantId || '',
    countryCode: apiTaxRate.countryCode || '',
    stateCode: apiTaxRate.stateCode || '',
    name: apiTaxRate.name || '',
    description: apiTaxRate.description || '',
    percentage: apiTaxRate.percentage || 0.0,
    accountingSystemId: apiTaxRate.accountingSystemId || '',
  };
}

export function taxRateToApi(apiTaxRate: TaxRate): TaxRateInterface {
  return {
    id: apiTaxRate.id || '',
    merchantId: apiTaxRate.merchantId || '',
    countryCode: apiTaxRate.countryCode || '',
    stateCode: apiTaxRate.stateCode || '',
    name: apiTaxRate.name || '',
    description: apiTaxRate.description || '',
    percentage: apiTaxRate.percentage || 0.0,
    accountingSystemId: apiTaxRate.accountingSystemId || '',
  };
}

export interface ListTaxRateFilter {
  merchantId?: string;
  includeArchived?: boolean;
  countryCode?: string;
  stateCode?: string;
  name?: string;
}

export interface CalculateTaxResponse {
  taxableAmount: number;
  taxRates: TaxRate[];
}

export interface LineItem {
  sku: string;
  amount: number;
}

export interface LineItemTaxes extends LineItem {
  taxRateIds?: string[];
}

export interface AppliedTax {
  amount: number;
  taxRateId: string;
  name: string;
  percentage: number;
  description: string;
}

export interface CalculateLineItemsTaxResponse {
  appliedTaxes: AppliedTax[];
  lineItemTaxes: LineItemTaxes[];
  totalTaxableAmount: number;
  taxRates: TaxRate[];
}
